import {
  INCO_TERMS_LIST,
  COUNTRY_LIST,
  UOM_TYPE_LIST,
  SALES_PERSON_LIST,
  DOCUMENT_TYPE_PURCHASE_LIST,
  DOCUMENT_TYPE_SALES_LIST,
  QUANTITY_TYPE_LIST,
  COMMODITYGROUP,
  CONTAINER_TYPE_LIST,
  OPERATOR_LIST,
  MOVE_TYPE,
  CURRENCY_LIST,
  CHARGE_BASIS_LIST,
  UOM_LIST,
  FILE_MANAGER_LIST,
  MASTER_COMPANY_DETAIL,
  STANDARD_TERMS_LIST,
  CHARGES_DESCRIPTION_LIST,
  ACCOUNT_ADDRESSBOOK_MODULE_LIST,
  ACCOUNT_ADDRESSBOOK_BASIS_LIST,
  CARRIER_LIST,
  OFFICE_TYPE,
  PROFIT_CENTER,
  PACKAGE_TYPE,
  MANUFACTURER_LIST,
  NOTES_TYPE,
  BL_TYPE_LIST,
  CLOADER_LIST,
  ROLE_LIST,
} from "./constant";

export const initStateFeed = {
  incoTermsList: [],
  countryList: [],
  uomTypeList: [],
  salesPersonList: [],
  documentTypePurchaseList: [],
  documentTypeSalesList: [],
  quantityTypeList: [],
  commodityGroupList: [],
  containerTypeList: [],
  operatorList: [],
  moveTypeList: [],
  currency_list: [],
  charges_basis_list: [],
  uomlist: [],
  fileManagerList: [],
  MasterCompanyDetails: [],
  standardTermsList: [],
  chargesDescriptionList: [],
  accountAddressBookModuleList: [],
  accountAddressBookBasisList: [],
  carrierList: [],
  officeTypeList: [],
  roleList: [],
  profitCenterList: [],
  notesTypeList: [],
  packageTypeList: [],
  blTypeList: [],
  coloaderList: [],
};

export default (state = initStateFeed, action) => {
  switch (action.type) {
    case INCO_TERMS_LIST: {
      return {
        ...state,
        incoTermsList: action.payload,
      };
    }
    case COUNTRY_LIST: {
      return {
        ...state,
        countryList: action.payload,
      };
    }
    case UOM_TYPE_LIST: {
      return {
        ...state,
        uomTypeList: action.payload,
      };
    }
    case SALES_PERSON_LIST: {
      return {
        ...state,
        salesPersonList: action.payload,
      };
    }
    case DOCUMENT_TYPE_PURCHASE_LIST: {
      return {
        ...state,
        documentTypePurchaseList: action.payload,
      };
    }
    case DOCUMENT_TYPE_SALES_LIST: {
      return {
        ...state,
        documentTypeSalesList: action.payload,
      };
    }
    case QUANTITY_TYPE_LIST: {
      return {
        ...state,
        quantityTypeList: action.payload,
      };
    }
    case COMMODITYGROUP: {
      return {
        ...state,
        commodityGroupList: action.payload,
      };
    }
    case CONTAINER_TYPE_LIST: {
      return {
        ...state,
        containerTypeList: action.payload,
      };
    }
    case OPERATOR_LIST: {
      return {
        ...state,
        operatorList: action.payload,
      };
    }
    case MOVE_TYPE: {
      return {
        ...state,
        moveTypeList: action.payload,
      };
    }
    case CURRENCY_LIST: {
      return {
        ...state,
        currency_list: action.payload,
      };
    }
    case CHARGE_BASIS_LIST: {
      return {
        ...state,
        charges_basis_list: action.payload,
      };
    }

    case UOM_LIST: {
      return {
        ...state,
        uomlist: action.payload,
      };
    }

    case FILE_MANAGER_LIST: {
      return {
        ...state,
        fileManagerList: action.payload,
      };
    }

    case MASTER_COMPANY_DETAIL: {
      return {
        ...state,
        MasterCompanyDetails: action.payload,
      };
    }

    case STANDARD_TERMS_LIST: {
      return {
        ...state,
        standardTermsList: action.payload,
      };
    }

    case CHARGES_DESCRIPTION_LIST: {
      return {
        ...state,
        chargesDescriptionList: action.payload,
      };
    }

    case ACCOUNT_ADDRESSBOOK_MODULE_LIST: {
      return {
        ...state,
        accountAddressBookModuleList: action.payload,
      };
    }
    case ACCOUNT_ADDRESSBOOK_BASIS_LIST: {
      return {
        ...state,
        accountAddressBookBasisList: action.payload,
      };
    }
    case CARRIER_LIST: {
      return {
        ...state,
        carrierList: action.payload,
      };
    }
    case OFFICE_TYPE: {
      return {
        ...state,
        officeTypeList: action.payload,
      };
    }

    case ROLE_LIST: {
      return {
        ...state,
        roleList: action.payload,
      };
    }

    case PROFIT_CENTER: {
      return {
        ...state,
        profitCenterList: action.payload,
      };
    }

    case PACKAGE_TYPE: {
      return {
        ...state,
        packageTypeList: action.payload,
      };
    }

    case NOTES_TYPE: {
      return {
        ...state,
        notesTypeList: action.payload,
      };
    }

    case BL_TYPE_LIST: {
      return {
        ...state,
        blTypeList: action.payload,
      };
    }

    case CLOADER_LIST: {
      return {
        ...state,
        coloaderList: action.payload,
      };
    }

    default:
      return state;
  }
};
